// extracted by mini-css-extract-plugin
module.exports = {"countdownWrapper":"style_countdownWrapper__95glP","countdownValue":"style_countdownValue__Xs_Sw","countdownName":"style_countdownName__WiAnU"};